import { addDays, max } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export const RESCHEDULE_WINDOW_DAYS = 14;

function createStableDate(year: number, month: number, day: number): Date {
  return new Date(Date.UTC(year, month - 1, day, 12, 0, 0, 0));
}

function extractDateParts(date: Date | string, timezone: string): [number, number, number] {
  const dateStr = formatInTimeZone(date, timezone, 'yyyy-MM-dd');
  return dateStr.split('-').map(Number) as [number, number, number];
}

export function getRescheduleWindowDates(
  appointmentDate: Date | string,
  timezone: string,
): {
  fromDate: Date;
  toDate: Date;
} {
  const now = new Date();
  const today = createStableDate(now.getFullYear(), now.getMonth() + 1, now.getDate());
  
  const [year, month, day] = extractDateParts(appointmentDate, timezone);
  const appointmentDateOnly = createStableDate(year, month, day);
  
  const fromDateBase = max([today, appointmentDateOnly]);
  // Start from today/appointment date (whichever is later) to allow same-day rescheduling
  const fromDate = fromDateBase;
  // Add 1 extra day to include the full 14-day window AFTER today (so 15 days total including today)
  const toDate = addDays(fromDate, RESCHEDULE_WINDOW_DAYS + 1);
  
  return { fromDate, toDate };
}

